import React from 'react'
import 'helpers/fontAwesomeLibSetup'
import { setupApplicationAction, removeCatchEarlyFlagAction } from 'actions/applicationActions'
import Calculator from 'components/Calculator'
import Loading from 'components/Loading'
import { connect } from 'react-redux'
import styles from 'globalStyles/index'
import injectSheet from 'react-jss'
import localStorageAvailable from 'helpers/localStorageAvailable'
import { UNIT_KEY } from 'helpers/globals'
import setUnitInLocalStorage from 'helpers/setUnitInLocalStorage'
import localStorage from 'helpers/localStorage'
import MobileStart from 'components/MobileStart'
import onMobile from 'helpers/onMobile'

const mapStateToProps = state => {
  const { createdAt, showMobileStart } = state
  return { createdAt, showMobileStart }
}

export class Application extends React.Component {
  state = { onMobile: onMobile() }

  componentDidMount() {
    if (!EXPORT) this.props.setupApplicationAction()
    if (localStorageAvailable() && !EXPORT && !localStorage.getItem(UNIT_KEY)) setUnitInLocalStorage()
  }

  componentWillUpdate(nextProps) {
    if (this.props.createdAt !== nextProps.createdAt) this.props.removeCatchEarlyFlagAction()
  }

  render() {
    const { props: { createdAt, showMobileStart }, state: { onMobile } } = this

    if (showMobileStart) return <MobileStart />
    return createdAt ? <Calculator /> : (onMobile ? <MobileStart /> : <Loading />)
  }
}

export default injectSheet(styles)(
  connect(mapStateToProps, { setupApplicationAction, removeCatchEarlyFlagAction })(Application)
)



// WEBPACK FOOTER //
// ./src/components/Application/index.js